export default __webpack_public_path__ + "static/media/nodata.5c3be73c.svg";